<div class="sidenav" fxLayout="column" *ngIf="mode !== 'hidden'">
    <ng-container *ngFor="let section of navigationButtonSections">
        <ng-container *ngIf="section.buttons.length">
            <!-- section -->
            <div class="section-name" [class.active]="section.active" *ngIf="section.sectionName">
                {{ section.sectionName }}
            </div>

            <!-- Navigation buttons -->
            <ng-container *ngFor="let btn of section.buttons">
                <a
                    [routerLinkActive]="'active'"
                    mat-icon-button
                    [routerLink]="[btn.routerLink]"
                    [matTooltip]="btn.name | translate"
                    matTooltipPosition="right"
                >
                    <mat-icon [svgIcon]="btn.svgIcon"></mat-icon>
                </a>
            </ng-container>
        </ng-container>
    </ng-container>
</div>
